import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IndustryRecord } from '../model/bvq/industry';
import { TransactionFilter } from '../model/bvq/transaction-filters';


@Injectable({
  providedIn: 'root'
})

export class LookupService {

  // List of states
  states = [
    {'value':'AL', 'name':'Alabama'},
    {'value':'AK', 'name':'Alaska'},
    {'value':'AZ', 'name':'Arizona'},
    {'value':'AR', 'name':'Arkansas'},
    {'value':'CA', 'name':'California'},
    {'value':'CO', 'name':'Colorado'},
    {'value':'CT', 'name':'Connecticut'},
    {'value':'DE', 'name':'Delaware'},
    {'value':'DC', 'name':'District Of Columbia'},
    {'value':'FL', 'name':'Florida'},
    {'value':'GA', 'name':'Georgia'},
    {'value':'HI', 'name':'Hawaii'},
    {'value':'ID', 'name':'Idaho'},
    {'value':'IL', 'name':'Illinois'},
    {'value':'IN', 'name':'Indiana'},
    {'value':'IA', 'name':'Iowa'},
    {'value':'KS', 'name':'Kansas'},
    {'value':'KY', 'name':'Kentucky'},
    {'value':'LA', 'name':'Louisiana'},
    {'value':'ME', 'name':'Maine'},
    {'value':'MD', 'name':'Maryland'},
    {'value':'MA', 'name':'Massachusetts'},
    {'value':'MI', 'name':'Michigan'},
    {'value':'MN', 'name':'Minnesota'},
    {'value':'MS', 'name':'Mississippi'},
    {'value':'MO', 'name':'Missouri'},
    {'value':'MT', 'name':'Montana'},
    {'value':'NE', 'name':'Nebraska'},
    {'value':'NV', 'name':'Nevada'},
    {'value':'NH', 'name':'New Hampshire'},
    {'value':'NJ', 'name':'New Jersey'},
    {'value':'NM', 'name':'New Mexico'},
    {'value':'NY', 'name':'New York'},
    {'value':'NC', 'name':'North Carolina'},
    {'value':'ND', 'name':'North Dakota'},
    {'value':'OH', 'name':'Ohio'},
    {'value':'OK', 'name':'Oklahoma'},
    {'value':'OR', 'name':'Oregon'},
    {'value':'PA', 'name':'Pennsylvania'},
    {'value':'RI', 'name':'Rhode Island'},
    {'value':'SC', 'name':'South Carolina'},
    {'value':'SD', 'name':'South Dakota'},
    {'value':'TN', 'name':'Tennessee'},
    {'value':'TX', 'name':'Texas'},
    {'value':'UT', 'name':'Utah'},
    {'value':'VT', 'name':'Vermont'},
    {'value':'VA', 'name':'Virginia'},
    {'value':'WA', 'name':'Washington'},
    {'value':'WV', 'name':'West Virginia'},
    {'value':'WI', 'name':'Wisconsin'},
    {'value':'WY', 'name':'Wyoming'}
  ];

  // Lookup subscription
  lookup = new BehaviorSubject<IndustryRecord>(new IndustryRecord());
  lookup$ = this.lookup.asObservable();

  // Lookup subscription
  filter = new BehaviorSubject<TransactionFilter>(new TransactionFilter());
  filter$ = this.filter.asObservable();

  constructor() { }

  updateLookup(lookup: IndustryRecord): void {
    this.lookup.next(lookup);
  }

  updateFilter(filter: TransactionFilter): void {
    this.filter.next(filter);
  }

  getCodeForAPI(): string {
    let str = '';
    str = this.lookup.getValue().NAICS.replace(/\s*$/, '').replace(/ /g, ':');
    if (str && this.lookup.getValue().SIC) {
      str += ':';
    }
    str += this.lookup.getValue().SIC.replace(/\s*$/, '').replace(/ /g, ':');
    return str;
  }

  getNaicsCodeForAPI(): string {
    let str = '';
    str = this.lookup.getValue().NAICS.replace(/\s*$/, '').replace(/ /g, ':');
    return str;
  }

  getSicCodeForAPI(): string {
    let str = '';
    str = this.lookup.getValue().SIC.replace(/\s*$/, '').replace(/ /g, ':');
    return str;
  }

  getStateName(value: string): string{
    let stateName = '';
    this.states.map((state) => {
      if(state.value === value)
        stateName = state.name;
    });
    return stateName;
  }

  getSelectedBcForAPI(): string {
    let str = '';
    this.lookup.getValue().SELECTED_BIZCOMP_TRAN.forEach(bc => {
      str += bc.ID + ':';
    });
    str = str.slice(0, -1);
    return str;
  }

  getSelectedDsForAPI(): string {
    let str = '';
    this.lookup.getValue().SELECTED_DEALSTATS_TRAN.forEach(ds => {
      str += ds.ID + ':';
    });
    str = str.slice(0, -1);
    return str;
  }

  getFilterCodeForAPI(): string {
    let str = '';
    if(this.filter.getValue().NAICS)
      str = this.filter.getValue().NAICS.join(':');
    if (str && this.filter.getValue().SIC) {
      str += ':';
    }
    if(this.filter.getValue().SIC)
      str += this.filter.getValue().SIC.join(':');
    return str;
  }
}
